<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    max-width="500"
    @input="onDialogChange"
  >
    <v-card>
      <v-card-title class="text-h5 primary--text">
        Workout Types
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item
            v-for="workoutType in workoutTypes"
            :key="workoutType.name"
            class="workout-type-item"
          >
            <template v-slot:default>
              <v-list-item-action>
                <v-checkbox
                  :input-value="isWorkoutTypeSelected(workoutType)"
                  @change="toggleWorkoutType(workoutType)"
                  color="primary"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ workoutType.name }}</v-list-item-title>
                <v-list-item-subtitle v-if="workoutType.children && workoutType.children.length > 0">
                  {{ workoutType.children.length }} subcategories
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="closeModal"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          @click="saveSelection"
          :disabled="selectedWorkoutTypes.length === 0"
        >
          Save ({{ selectedWorkoutTypes.length }})
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "WorkoutTypeModal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    workoutTypes: {
      type: Array,
      default: () => []
    },
    selectedItem: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selectedWorkoutTypes: []
    };
  },
  computed: {
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    }
  },
  watch: {
    show(newVal) {
      if (newVal && this.selectedItem && this.selectedItem.workoutType) {
        // Initialize selected workout types from the selected item
        this.selectedWorkoutTypes = [...this.selectedItem.workoutType];
      } else if (!newVal) {
        // Reset when modal closes
        this.selectedWorkoutTypes = [];
      }
    }
  },
  methods: {
    toggleWorkoutType(workoutType) {
      const index = this.selectedWorkoutTypes.findIndex(
        wt => wt.name === workoutType.name
      );
      
      if (index > -1) {
        // Remove if already selected
        this.selectedWorkoutTypes.splice(index, 1);
      } else {
        // Add if not selected
        this.selectedWorkoutTypes.push(workoutType);
      }
    },
    saveSelection() {
      this.$emit('select', this.selectedWorkoutTypes);
      this.closeModal();
    },
    closeModal() {
      this.selectedWorkoutTypes = [];
      this.$emit('close');
    },
    onDialogChange(value) {
      if (!value) {
        this.closeModal();
      }
    },
    isWorkoutTypeSelected(workoutType) {
      return this.selectedWorkoutTypes.some(
        wt => wt.name === workoutType.name
      );
    }
  }
};
</script>

<style scoped>
.workout-type-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.workout-type-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
